import { coreResources } from '#core/i18n/resources.ts';

import { i18n as chatResources } from '#plugin-chat';

export const resources = {
  en: {
    ...coreResources.en,
    ...chatResources.en,
  },
};
